// extracted by mini-css-extract-plugin
var _1 = "VY4Ga";
var _2 = "KgsBg";
export { _1 as "limit-exceeded", _2 as "seats" }
